import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class AcceptLanguageHeaderHttpInterceptor implements HttpInterceptor {
  constructor(private translate: TranslateService) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const language = this.translate.currentLang;

    if (language) {
      const headers = req.headers.set("Accept-Language", language);

      const cloneReq = req.clone({ headers });

      return next.handle(cloneReq);
    } else {
      return next.handle(req);
    }
  }
}
